import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-form-group-title",
    templateUrl: "./form-group-title.component.html",
    styleUrls: ["./form-group-title.component.scss"],
    standalone: false,
})
export class FormGroupTitleComponent implements OnInit {
    @Input() title: string;

    constructor() {}

    ngOnInit(): void {}
}
